import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-101c41c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "accountApply-applyDetail" }
const _hoisted_2 = { class: "accountApply-detail-wrapper" }
const _hoisted_3 = { class: "accountApply-detail" }
const _hoisted_4 = { class: "item text-overflow" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "营业执照名称：", -1))
const _hoisted_6 = {
  class: "item text-overflow",
  style: {"width":"350px"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "系统公司简称：", -1))
const _hoisted_8 = { class: "item text-overflow" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "纳税识别号：", -1))
const _hoisted_10 = { class: "item text-overflow" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "法人：", -1))
const _hoisted_12 = {
  class: "item text-overflow",
  style: {"width":"350px"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "纳税类型：", -1))
const _hoisted_14 = { class: "item text-overflow" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "股东全称：", -1))
const _hoisted_16 = { class: "sign-table-wrapper" }

import {
  ref,
  onMounted,
  withDefaults,
  watch,
} from "vue";
import HeadTitle from "@/components/HeadTitle.vue";
import RisTable from "@/components/Table.vue";
import { accountSetApplicationDetail } from "@/api/process_accountApply";


export default /*#__PURE__*/_defineComponent({
  props: {
    folwId: { default: 0 },
    update: { type: Boolean, default: false }
  },
  emits: ["change-status"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { folwId: number, update: boolean }





const form = ref({
  LicenseName: "",
  CompanyName: "",
  TaxNumber: "",
  LegalPersons: "",
  TaxPayerTypeText: "",
  ShareholderFullName: "",
});

watch(
  () => props.update,
  (val, oldValue) => {
    if (val !== oldValue) {
      getdata();
    }
  }
  // { immediate: true }
);
const tableData = ref<
  { FileName?: string; AccessoryType: number; FileUrl?: string }[]
>([]);

const getdata = async () => {
  const { Data } = await accountSetApplicationDetail({
    Id: props.folwId,
    IsApproveDetail: 1,
  });
  form.value = Data?.PageData;
  if (Data?.PageFiles.length > 0) {
    tableData.value = Data?.PageFiles;
  } else {
    tableData.value = [];
  }

  $emit("change-status", {
    buttons: Data?.ActionButtons,
    flowId: Data?.WorkFlowId,
    ApplicationInfo:Data?.ApplicationInfo,
    ApplicationTime:Data?.ApplicationTime
  });
};

onMounted(async () => {
  getdata();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeadTitle, {
      title: "账套申请流程",
      style: {"margin-top":"24px"}
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", null, _toDisplayString(form.value.LicenseName), 1)
          ]),
          _createElementVNode("span", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("span", null, _toDisplayString(form.value.CompanyName), 1)
          ]),
          _createElementVNode("span", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("span", null, _toDisplayString(form.value.TaxNumber), 1)
          ]),
          _createElementVNode("span", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("span", null, _toDisplayString(form.value.LegalPersons), 1)
          ]),
          _createElementVNode("span", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("span", null, _toDisplayString(form.value.TaxTypeText), 1)
          ]),
          _createElementVNode("span", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("span", null, _toDisplayString(form.value.ShareholderFullName), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(RisTable, { "table-data": tableData.value }, null, 8, ["table-data"])
      ])
    ])
  ], 64))
}
}

})